// extracted by css-extract-rspack-plugin
export default {"card":"V0QHCn3HnEIYoWTO","remoteRow":"iIBEw5K3SbMVGUYS","info":"mpUQ6OY0tmwTEDx4","url":"xOze6bTbpnsQio0X","transport":"QrxJH0N9XP0MevLR","actions":"zykFmrwlEbQX4cqa"};